import AddEditEndpoint from './AddEditEnpoint';
import { EndpointFormData } from './EiapClusterInterfaces';
import ReactEDSWrapper from '../../utils/react-eds-wrapper';
import ReactDOM from 'react-dom';
import { Button, Dialog } from '@dsi/react-eds';
import { useState } from 'react';

interface PropsObject {
    onSave: (values: EndpointFormData) => void;
    onCancel: () => void;
    endpoint: EndpointFormData | undefined;
    endpointType: string;
    open: boolean;
}

const AddEditEndpointDialog = (props: PropsObject) => {

    const [saveNow, setSaveNow] = useState<number>(0);

    const getSubTitle = () => {
        if (props.endpointType === 'RLO') {
            return 'RAN Lifecycle Orchestrator'
        }
        if (props.endpointType === 'EIC') {
            return 'Ericsson Intelligent Controller'
        }
        if (props.endpointType === 'EOLM') {
            return 'Ericsson Orchestrator Lifecycle Management'
        }
    }

    const handleSave = (values: EndpointFormData) => {
        setSaveNow(0);
        props.onSave(values);
    }

    const handleError = () => {
        setSaveNow(0);
    }

    return ReactDOM.createPortal(
    <ReactEDSWrapper
      component={Dialog}
      show={props.open}
      onClose={props.onCancel}
      title={props.endpoint?.url ? 
        `Edit ${props.endpointType?.toUpperCase()} Endpoint` : 
        `Create ${props.endpointType?.toUpperCase()} Endpoint`}
      subtitle={getSubTitle()}
      data-type="fullscreen"
      className="AddEditEiapClusterDialog fullscreen"
      bottom={
        <ReactEDSWrapper
          component={Button}
          primary
          className="btn primary"
          type="submit"
          onClick={() => setSaveNow(1)}
        >
          {props.endpoint?.url ? 'Update' : 'Create'}
        </ReactEDSWrapper>
      }
    >
      {props.open && (
        <AddEditEndpoint 
            onSave={handleSave} 
            onError={handleError}
            endpoint={props.endpoint} 
            endpointType={props.endpointType} 
            saveNow={saveNow}
        />
      )}
    </ReactEDSWrapper>,
    document.body
  );
    
}
export default AddEditEndpointDialog;